import React from 'react'
// import {$} from 'react-jquery-plugin'

export default function FOOTER() {

    return (
        <>
            <div className='footer' id='footer'>
           
            <div className='flex1'>
            <i class="far fa-registered"></i>
                    <div>All Rights Reserved</div>
                    <div>Done By</div>
                    <div>Rabee Aljaramani</div>
                    </div>
                    <div className='flex2'>
                    <i class="fab fa-facebook"></i>
                    <i class="fab fa-instagram"></i>
                    <i class="fab fa-twitter"></i>
                    <i class="fab fa-linkedin"></i>
                    </div>
           
            </div>
        </>
    )
}
